import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();
  return (
    <img
      className={classes.img}
      src="/aunoa-logo.png"
      alt="Aunoa"
    />
  );
};

export default LogoIcon;
